module.exports = __webpack_public_path__ + "img/feature-plan-sm.c68023da.png";